package core.enums

import kotlinx.serialization.Serializable

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 27.09.22
 * Author : mariorosshirt
 */

@Serializable
enum class EPostMessageActions {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    READY,

    SET_COLOURS,

    SHUFFLE,

    SET_HIGHLIGHT,

    TOGGLE_COLOUR,

    EXPORT,

    SET_FIXED_LIST,

    SHARE_NATIVE,

    EXPORT_NATIVE

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}